export default __webpack_public_path__ + "static/media/team2.e3002d6a.png";